const updateAccessInLocalStorage = (accessArray) => {
  let user = JSON.parse(localStorage.getItem("bigfoot-admin"));
  user = { ...user, access: accessArray };
  localStorage.setItem("bigfoot-admin", JSON.stringify(user));
};

export default updateAccessInLocalStorage;
